<div class="menu-titulo-interno">
    <ng-content select=".sub-menu-padrao"></ng-content>
</div>
<div class="corpo-card-padrao-com-nav-bar-header-footer">
    <ng-content select=".body-card-padrao"></ng-content>
</div>
<div class="footer-card">
    <ng-content select=".footer-card-padrao"></ng-content>
</div>
